import type { StreakProjectionResponse } from '@library/types/streaks';

export const normalizeStreakProjection = (
  response: StreakProjectionResponse
) => {
  const { included: includedData, data: projections } = response;

  return projections.map((projection) => {
    const playerIncluded = includedData.find(
      (included) =>
        included.type === 'new_player' &&
        included.id === projection.relationships.new_player.data?.id
    );
    return {
      ...projection,
      player: playerIncluded
    };
  });
};
